const handleHoverColor = (el) => {
  el.setAttribute("data-old-style", btoa(el.style.cssText, true));
  el.style.border = `2px solid ${el.getAttribute("data-hover-color")}`;
};
const handleTargetStyle = (el) => {
  const target = el.querySelector(el.getAttribute("data-hover-target"));
  if (!target) {
    return;
  }
  target.style.backgroundColor = el.getAttribute("data-hover-color");
  el.style.cursor = "pointer";
};
const handleResetStyle = (el) => {
  el.style = atob(el.getAttribute("data-old-style"), true);
  el.removeAttribute("data-old-style");
};
const handleResetTargetStyle = (el) => {
  const target = el.querySelector(el.getAttribute("data-hover-target"));
  if (!target) {
    return;
  }
  target.style.backgroundColor = "";
};

const handleClick = (ev) => {
  let el = ev.target;

  if (!el.getAttribute("data-hover-target")) {
    el = el.closest("[data-enable-hover]");
  }
  if (!el || !el.getAttribute("data-hover-target")) {
  }
  const target = el.querySelector(el.getAttribute("data-hover-target"));
  if (!target) {
    return;
  }
  target.click();
};

const addedHoverElements = new Set();
const addHoverElements = () => {
  document.querySelectorAll("[data-enable-hover]").forEach((el) => {
    if (addedHoverElements.has(el)) {
      return;
    }
    addedHoverElements.add(el);
    // On hover: we get the attributes, store the old styles and applies the hover styles.
    el.addEventListener("mouseover", () => {
      el.classList.add("hovering");
      if (
        el.hasAttribute("data-hover-color") &&
        el.hasAttribute("data-hover-border")
      ) {
        handleHoverColor(el);
      }
      if (el.hasAttribute("data-hover-target")) {
        handleTargetStyle(el);
        el.addEventListener("click", handleClick);
      }
    });
    // When we exit the hover, we reset the styles using the old styles.
    el.addEventListener("mouseout", () => {
      el.classList.remove("hovering");
      if (
        el.hasAttribute("data-old-style") &&
        el.hasAttribute("data-hover-border")
      ) {
        handleResetStyle(el);
      }
      if (el.hasAttribute("data-hover-target")) {
        handleResetTargetStyle(el);
        el.removeEventListener("click", handleClick);
      }
    });
  });
};

window.addEventListener("DOMContentLoaded", () => {
  addHoverElements();
  new MutationObserver(addHoverElements).observe(document.body, {
    childList: true,
    subtree: true,
  });
});
